import { FirebaseContext } from '@/context';
import { useContext } from 'react';

export function useFirebase() {
  return useContext(FirebaseContext);
}
